module.exports = __webpack_public_path__ + "img/dashboard_popular_cookbook_title_en.4abacf90.png";